<div class="">
  <a [routerLink]="['/home']" class="b-brand">
    <div class="b-bg">
      <i class="feather icon-command"></i>
    </div>
    <span class="b-title">Telchi</span>
  </a>
  <a href="javascript:" class="mobile-menu" [ngClass]="{ on: navCollapsed }" id="mobile-collapse" (click)="navCollapse()"><span></span></a>
</div>
